module.exports = __webpack_public_path__ + "static/img_9644-f724974316a33334b8ef9f40a3cac73f.webp";